export const faqItems = [
  {
    id: 'faq-1',
    question: '51黑料是什么？',
    answer: '51黑料吃瓜网是一个汇聚每日最新娱乐八卦与热点爆料的资讯平台，提供全网热门黑料视频、实时吃瓜内容与独家深度解读。我们覆盖51黑料网一区二区等热门频道，致力于为吃瓜群众提供最全、最快、最真实的爆料动态。'
  },
  {
    id: 'faq-2',
    question: '51黑料的内容多久更新一次？',
    answer: '我们全天候实时监控全网热点，确保今日黑料首页内容保持最新状态。编辑团队7×24小时轮值，从爆料线索收集到内容审核发布，平均响应时间不超过30分钟，让您不错过任何一个热门大瓜。'
  },
  {
    id: 'faq-3',
    question: '如何获取51黑料在线观看入口？',
    answer: '您可以直接通过本页面浏览所有内容，也可以将51黑料官网添加到浏览器收藏夹。我们提供稳定的在线观看体验，覆盖51黑料不打烊全天候内容，支持桌面端和移动端流畅访问。'
  },
  {
    id: 'faq-4',
    question: '如何参与每日黑料大赛或投稿爆料？',
    answer: '每日黑料大赛是51黑料社区的核心互动活动，用户可通过评论区参与话题讨论、投票评选当日最热黑料。如果您有独家爆料线索，欢迎通过页面底部的联系我们模块提交，经编辑审核后有机会登上首页推荐位。'
  },
];

export const aboutContent = {
  title: '关于51黑料',
  description: '51黑料吃瓜网成立于2022年，是国内领先的娱乐八卦与热点爆料聚合平台。我们以"不放过每一口瓜"为核心理念，深耕娱乐圈、网红圈、社会热点三大内容领域，覆盖51黑料网一区二区、51黑料不打烊等热门频道。\n\n平台拥有专业的编辑团队与遍布全网的内容采编网络，每日精选最具话题性的黑料视频与吃瓜内容，通过今日黑料首页、每日黑料大赛等形式实现内容的高效分发。截至当前，平台累计发布独家爆料超过5000条，月度活跃用户突破百万级，已成为吃瓜爱好者首选的在线观看入口。\n\n我们坚持内容真实、更新及时、体验流畅三大原则，持续优化51黑料在线观看体验，让每一位用户都能在这里找到最对胃口的瓜。'
};

export const topicTags = [
  { id: 't1', name: '今日黑料', hot: true, count: '12.8万' },
  { id: 't2', name: '51黑料不打烊', hot: true, count: '9.6万' },
  { id: 't3', name: '每日黑料大赛', hot: true, count: '8.3万' },
  { id: 't4', name: '娱乐圈大瓜', hot: true, count: '7.1万' },
  { id: 't5', name: '网红翻车现场', hot: false, count: '5.4万' },
  { id: 't6', name: '独家曝光', hot: true, count: '4.9万' },
  { id: 't7', name: '吃瓜第一线', hot: false, count: '4.2万' },
  { id: 't8', name: '黑料视频', hot: true, count: '3.8万' },
  { id: 't9', name: '实时爆料', hot: false, count: '3.5万' },
  { id: 't10', name: '社会热点', hot: false, count: '3.1万' },
  { id: 't11', name: '深度扒皮', hot: false, count: '2.7万' },
];

export const carouselItems = [
  {
    id: 'c1',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20editorial%20illustration%20of%20entertainment%20gossip%20news%20with%20warm%20coral%20and%20orange%20tones%2C%20stylized%20abstract%20shapes%20floating%20in%20composition%2C%20megaphone%20and%20news%20elements%2C%20modern%20flat%20design%20with%20soft%20gradients%2C%20dramatic%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20magazine%20quality%2C%20warm%20neutral%20background&width=700&height=440&seq=carousel-1-heiliao&orientation=landscape',
    tag: '独家曝光',
    title: '当红顶流深夜密会神秘女子，工作室紧急发声明回应',
    summary: '据知情人士透露，某当红男星近日被拍到与一位神秘女子深夜同返公寓，画面清晰可见两人举止亲密。该事件在51黑料网引发巨大讨论，粉丝群体出现严重分裂，目前相关话题已登上51黑料网今日黑料首页热一位置。',
    date: '2026-07-19',
    views: '128.5万',
    comments: '3.2万'
  },
  {
    id: 'c2',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20social%20media%20drama%20and%20online%20controversy%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20floating%20speech%20bubbles%20and%20news%20fragments%2C%20stylized%20geometric%20shapes%2C%20modern%20editorial%20design%2C%20soft%20gradient%20background%2C%20clean%20composition%20with%20dramatic%20contrast&width=700&height=440&seq=carousel-2-heiliao&orientation=landscape',
    tag: '网红翻车',
    title: '千万粉网红直播带货翻车，品牌方连夜解约索赔',
    summary: '某拥有千万粉丝的头部网红在最新一场直播带货中出现严重翻车事故，不仅产品质量遭到消费者集体投诉，其本人的不当言论也引发舆论风波。多个品牌方已紧急发布解约声明，51黑料不打烊频道将持续跟进事件进展。',
    date: '2026-07-18',
    views: '96.3万',
    comments: '2.8万'
  },
  {
    id: 'c3',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20art%20of%20celebrity%20scandal%20breaking%20news%2C%20warm%20terracotta%20and%20golden%20tones%2C%20abstract%20composition%20with%20newspaper%20and%20digital%20elements%2C%20modern%20magazine%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20floating%20fragments%2C%20clean%20minimalist%20style%20with%20warm%20atmosphere&width=700&height=440&seq=carousel-3-heiliao&orientation=landscape',
    tag: '娱乐圈大瓜',
    title: '知名导演被爆剧组霸凌，多位演员实名指控引热议',
    summary: '近日多位曾经合作过的演员通过51黑料社区实名曝光某知名导演在片场的霸凌行为，包括言语侮辱、超时工作、随意删改戏份等多项指控。事件迅速成为每日黑料大赛热门话题，行业内外广泛关注。',
    date: '2026-07-17',
    views: '85.7万',
    comments: '4.1万'
  },
  {
    id: 'c4',
    image: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20illustration%20of%20internet%20expose%20and%20whistleblowing%2C%20warm%20orange%20and%20peach%20color%20scheme%2C%20dynamic%20floating%20document%20shapes%20and%20magnifying%20glass%20elements%2C%20clean%20editorial%20design%2C%20soft%20gradient%20background%2C%20dramatic%20composition%2C%20magazine%20quality&width=700&height=440&seq=carousel-4-heiliao&orientation=landscape',
    tag: '深度扒皮',
    title: '某上市公司高管私密聊天记录泄露，资本运作内幕曝光',
    summary: '一份据称来自某知名上市公司高管的私密聊天记录在51黑料网一区二区频道被曝光，内容涉及多起资本运作内幕与利益输送细节。目前涉事公司尚未作出正式回应，但相关话题已在51黑料在线观看频道持续发酵。',
    date: '2026-07-16',
    views: '67.2万',
    comments: '5.6万'
  },
  {
    id: 'c5',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20editorial%20illustration%20of%20music%20industry%20controversy%20and%20copyright%20dispute%2C%20warm%20golden%20and%20coral%20tones%2C%20floating%20musical%20notes%20and%20legal%20document%20shapes%2C%20modern%20abstract%20design%2C%20soft%20dramatic%20lighting%2C%20clean%20minimalist%20composition%2C%20magazine%20editorial%20quality&width=700&height=440&seq=carousel-5-heiliao&orientation=landscape',
    tag: '黑料视频',
    title: '选秀节目冠军疑似假唱实锤流出，节目组连夜修改赛制',
    summary: '一段疑似某选秀节目冠军选手的现场录音对比视频在51黑料视频频道热传，音频分析显示存在明显的假唱痕迹。该事件在51黑料吃瓜网引发连锁反应，节目组已紧急宣布修改后续赛制，但观众质疑声依然不断。',
    date: '2026-07-15',
    views: '59.8万',
    comments: '2.3万'
  },
];

export const rankingItems = [
  { id: 'r1', rank: 1, title: '顶流男星深夜密会神秘女子', heat: '128.5万', tag: '爆', trend: 'up' },
  { id: 'r2', rank: 2, title: '千万粉网红直播带货翻车', heat: '96.3万', tag: '热', trend: 'up' },
  { id: 'r3', rank: 3, title: '知名导演剧组霸凌遭实名指控', heat: '85.7万', tag: '热', trend: 'same' },
  { id: 'r4', rank: 4, title: '上市公司高管私密聊天记录泄露', heat: '67.2万', tag: '新', trend: 'up' },
  { id: 'r5', rank: 5, title: '选秀冠军假唱实锤对比视频流出', heat: '59.8万', tag: '热', trend: 'down' },
];

export const indexItems = [
  { id: 'idx1', title: '今日黑料首页', description: '每日精选最热门黑料视频与吃瓜内容，实时更新不容错过', icon: 'ri-fire-line', count: 128 },
  { id: 'idx2', title: '51黑料一区', description: '娱乐圈深度八卦与明星私密爆料专区，最全明星瓜一手掌握', icon: 'ri-star-line', count: 96 },
  { id: 'idx3', title: '51黑料二区', description: '网红圈、直播圈翻车现场与行业乱象揭秘', icon: 'ri-flashlight-line', count: 84 },
  { id: 'idx4', title: '51黑料不打烊', description: '24小时不间断更新，深夜档独家内幕与突发爆料', icon: 'ri-moon-line', count: 72 },
  { id: 'idx5', title: '每日黑料大赛', description: '全民票选当日最炸裂黑料，你的投票决定谁上头条', icon: 'ri-trophy-line', count: 65 },
  { id: 'idx6', title: '黑料视频', description: '高清现场视频实锤合集，最直观的吃瓜观看体验', icon: 'ri-vidicon-line', count: 58 },
  { id: 'idx7', title: '深度扒皮', description: '专业编辑团队深度调查与梳理，还原事件来龙去脉', icon: 'ri-search-eye-line', count: 47 },
  { id: 'idx8', title: '吃瓜社区', description: '百万吃瓜群众在线交流，弹幕评论实时互动嗨翻全场', icon: 'ri-chat-smile-2-line', count: 39 },
];

export const updatesItems = [
  { id: 'u1', time: '10分钟前', content: '某知名女星被拍到与圈外男友甜蜜逛街，疑似恋情曝光', tag: '新' },
  { id: 'u2', time: '28分钟前', content: '热门综艺录制现场突发意外，选手与导师发生激烈争执', tag: '热' },
  { id: 'u3', time: '1小时前', content: '某品牌代言人涉嫌虚假宣传被市场监管部门立案调查', tag: '爆' },
  { id: 'u4', time: '2小时前', content: '知名编剧发文暗讽某流量明星，双方粉丝在评论区展开大战', tag: '热' },
  { id: 'u5', time: '3小时前', content: '年度音乐盛典入围名单公布，多位歌手质疑评选标准', tag: '' },
  { id: 'u6', time: '5小时前', content: '某平台头部主播直播间被封，疑似涉及违规内容', tag: '新' },
  { id: 'u7', time: '7小时前', content: '热门网剧剧组被爆拖欠群演工资，工会介入协调', tag: '' },
  { id: 'u8', time: '9小时前', content: '知名导演新片路演现场遭遇观众犀利提问，场面一度尴尬', tag: '热' },
];

export const commentsItems = [
  {
    id: 'cm1',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20person%20with%20casual%20style%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20composition%2C%20friendly%20expression&width=80&height=80&seq=avatar-1-heiliao&orientation=squarish',
    nickname: '吃瓜不嫌事大',
    time: '15分钟前',
    content: '这个瓜是真的炸裂啊！我追了三天三夜，每一条新料都让人瞠目结舌。51黑料的速度确实没得说，比其他平台至少快半天。',
    likes: 2836,
    tag: '热评'
  },
  {
    id: 'cm2',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20modern%20style%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20composition%2C%20confident%20expression&width=80&height=80&seq=avatar-2-heiliao&orientation=squarish',
    nickname: '深夜吃瓜人',
    time: '32分钟前',
    content: '每日期待打开51黑料看今天有什么新瓜，已经成了一种习惯了。编辑团队真的很拼，凌晨三点还在更新内容，respect！',
    likes: 1954,
    tag: ''
  },
  {
    id: 'cm3',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%20with%20stylish%20look%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20composition%2C%20thoughtful%20expression&width=80&height=80&seq=avatar-3-heiliao&orientation=squarish',
    nickname: '理性吃瓜群众',
    time: '1小时前',
    content: '看了这么多爆料平台，51黑料的信息核实做得相对比较严谨了，至少不会乱传谣言。希望继续保持这个标准。',
    likes: 1587,
    tag: ''
  },
  {
    id: 'cm4',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20trendy%20style%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20composition%2C%20smiling%20expression&width=80&height=80&seq=avatar-4-heiliao&orientation=squarish',
    nickname: '瓜田里的猹',
    time: '2小时前',
    content: '每日黑料大赛这个环节太有意思了，每天都要来投一票。看到自己选的黑料冲到榜一，比追剧还刺激哈哈哈！',
    likes: 1203,
    tag: ''
  },
  {
    id: 'cm5',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20person%20with%20artsy%20style%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20composition%2C%20relaxed%20expression&width=80&height=80&seq=avatar-5-heiliao&orientation=squarish',
    nickname: '八卦研究中心',
    time: '3小时前',
    content: '建议51黑料出一个App版本！现在每天在手机浏览器刷太费流量了，出个App我第一个下载支持，付费订阅也愿意。',
    likes: 986,
    tag: ''
  },
];

export const featuresItems = [
  {
    id: 'f1',
    icon: 'ri-speed-up-line',
    title: '极速更新',
    description: '7×24小时全天候内容监控，平均30分钟响应速度，确保您第一时间获取最新黑料动态与独家爆料。覆盖51黑料网一区二区全频道实时推送。'
  },
  {
    id: 'f2',
    icon: 'ri-shield-check-line',
    title: '信息核实',
    description: '专业编辑团队多重交叉验证，拒绝虚假谣言传播。每一条登上51黑料今日首页的内容都经过严格的事实核查与来源确认。'
  },
  {
    id: 'f3',
    icon: 'ri-group-line',
    title: '社区互动',
    description: '百万吃瓜用户在线交流，每日黑料大赛全民投票评选。弹幕评论、话题讨论、投票互动，让吃瓜不再是一个人的狂欢。'
  },
];

export const contactContent = {
  title: '联系我们',
  description: '如果您有独家爆料线索、商务合作需求或内容投诉建议，欢迎通过以下方式联系我们。51黑料编辑团队期待与每一位吃瓜群众和行业伙伴建立联系。',
  email: 'tips@51heiliao.com',
  wechat: '51heiliao_official',
  tips: '爆料一经采用，将获得首页推荐位与现金奖励。'
};

export const cardsItems = [
  {
    id: 'cd1',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20celebrity%20gossip%20news%20with%20warm%20coral%20and%20peach%20tones%2C%20abstract%20floating%20shapes%2C%20soft%20dramatic%20lighting%2C%20modern%20magazine%20design%2C%20clean%20minimalist%20composition%2C%20warm%20neutral%20background&width=480&height=320&seq=card-1-heiliao&orientation=landscape',
    title: '娱乐圈年度十大未解之谜大盘点',
    tag: '深度扒皮',
    date: '2026-07-19',
    views: '56.3万'
  },
  {
    id: 'cd2',
    image: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20art%20of%20social%20media%20influencer%20drama%2C%20warm%20orange%20and%20amber%20color%20scheme%2C%20floating%20icon%20shapes%2C%20clean%20editorial%20style%2C%20soft%20gradient%20background%2C%20magazine%20quality%20composition%2C%20warm%20atmosphere&width=480&height=320&seq=card-2-heiliao&orientation=landscape',
    title: '短视频平台头部创作者收入揭秘',
    tag: '网红翻车',
    date: '2026-07-18',
    views: '43.8万'
  },
  {
    id: 'cd3',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20editorial%20illustration%20of%20music%20festival%20behind%20scenes%20drama%2C%20warm%20terracotta%20and%20golden%20tones%2C%20abstract%20geometric%20shapes%2C%20modern%20magazine%20design%2C%20soft%20lighting%2C%20clean%20minimalist%20composition%2C%20warm%20neutral%20background&width=480&height=320&seq=card-3-heiliao&orientation=landscape',
    title: '某音乐节后台混乱场面独家视频流出',
    tag: '黑料视频',
    date: '2026-07-17',
    views: '38.5万'
  },
  {
    id: 'cd4',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20fashion%20industry%20controversy%2C%20warm%20peach%20and%20coral%20palette%2C%20floating%20document%20shapes%2C%20modern%20editorial%20design%2C%20soft%20dramatic%20lighting%2C%20clean%20composition%2C%20magazine%20quality%2C%20warm%20atmosphere&width=480&height=320&seq=card-4-heiliao&orientation=landscape',
    title: '时装周某品牌设计师涉嫌抄袭事件始末',
    tag: '独家曝光',
    date: '2026-07-16',
    views: '32.1万'
  },
  {
    id: 'cd5',
    image: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20art%20of%20TV%20reality%20show%20scandal%2C%20warm%20orange%20and%20golden%20color%20scheme%2C%20abstract%20floating%20elements%2C%20clean%20magazine%20design%2C%20soft%20gradient%20background%2C%20dramatic%20composition%2C%20warm%20neutral%20atmosphere&width=480&height=320&seq=card-5-heiliao&orientation=landscape',
    title: '真人秀节目后期剪辑涉嫌恶意剪辑遭声讨',
    tag: '吃瓜第一线',
    date: '2026-07-15',
    views: '28.9万'
  },
  {
    id: 'cd6',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20esports%20gaming%20drama%2C%20warm%20coral%20and%20amber%20tones%2C%20floating%20geometric%20shapes%2C%20modern%20editorial%20style%2C%20soft%20lighting%2C%20clean%20minimalist%20composition%2C%20magazine%20quality%2C%20warm%20background&width=480&height=320&seq=card-6-heiliao&orientation=landscape',
    title: '电竞圈某战队内部矛盾激化，核心选手或将离队',
    tag: '实时爆料',
    date: '2026-07-14',
    views: '25.6万'
  },
  {
    id: 'cd7',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20book%20publishing%20scandal%2C%20warm%20peach%20and%20terracotta%20color%20palette%2C%20abstract%20shapes%20floating%2C%20modern%20magazine%20design%2C%20soft%20dramatic%20lighting%2C%20clean%20composition%2C%20warm%20neutral%20background&width=480&height=320&seq=card-7-heiliao&orientation=landscape',
    title: '畅销书作家被爆代笔，出版社紧急下架相关作品',
    tag: '社会热点',
    date: '2026-07-13',
    views: '22.3万'
  },
];

export const appContent = {
  title: '51黑料移动端',
  subtitle: '随时随地，一口好瓜不错过',
  description: '51黑料移动版已全面适配手机与平板设备，无需下载安装即可获得流畅的在线观看体验。将本站添加到手机桌面，即可像使用App一样快捷访问51黑料不打烊全天候内容，参与每日黑料大赛互动投票。',
  features: ['高清视频流畅播放', '实时推送最新爆料', '一键参与每日黑料大赛', '弹幕评论即时互动'],
  qrImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20QR%20code%20style%20graphic%20with%20warm%20coral%20and%20orange%20accents%2C%20abstract%20geometric%20pattern%2C%20clean%20tech%20aesthetic%2C%20soft%20gradient%20background%2C%20warm%20neutral%20tones%2C%20high%20contrast%20design%2C%20modern%20app%20download%20visual&width=260&height=260&seq=qr-heiliao-app&orientation=squarish'
};

export const mediaItems = [
  {
    id: 'm1',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20style%20image%20of%20entertainment%20news%20studio%20scene%2C%20warm%20coral%20and%20orange%20lighting%2C%20abstract%20geometric%20play%20button%20overlay%2C%20modern%20editorial%20design%2C%20soft%20dramatic%20shadows%2C%20clean%20composition%2C%20widescreen%20format%2C%20professional%20broadcast%20aesthetic&width=480&height=300&seq=media-1-heiliao&orientation=landscape',
    title: '顶流男星密会事件全程时间线梳理',
    duration: '08:32',
    views: '128.5万',
    tag: '热门'
  },
  {
    id: 'm2',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20of%20live%20streaming%20drama%20scene%2C%20warm%20amber%20and%20peach%20color%20palette%2C%20abstract%20play%20icon%20overlay%2C%20modern%20broadcast%20design%2C%20soft%20dramatic%20lighting%2C%20clean%20widescreen%20composition%2C%20professional%20aesthetic&width=480&height=300&seq=media-2-heiliao&orientation=landscape',
    title: '网红带货翻车现场完整回放与品牌方回应',
    duration: '12:15',
    views: '96.3万',
    tag: ''
  },
  {
    id: 'm3',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20style%20of%20celebrity%20interview%20breaking%20news%2C%20warm%20terracotta%20and%20golden%20tones%2C%20abstract%20play%20button%20design%2C%20modern%20editorial%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20clean%20widescreen%2C%20broadcast%20quality&width=480&height=300&seq=media-3-heiliao&orientation=landscape',
    title: '导演霸凌事件受害演员独家专访实录',
    duration: '15:48',
    views: '85.7万',
    tag: '独家'
  },
  {
    id: 'm4',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20of%20business%20news%20expose%20report%2C%20warm%20orange%20and%20peach%20color%20scheme%2C%20abstract%20play%20icon%20overlay%2C%20modern%20broadcast%20design%2C%20soft%20dramatic%20shadows%2C%20clean%20widescreen%20composition%2C%20professional%20aesthetic&width=480&height=300&seq=media-4-heiliao&orientation=landscape',
    title: '上市公司高管聊天记录全量曝光与深度解读',
    duration: '22:06',
    views: '67.2万',
    tag: ''
  },
  {
    id: 'm5',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20of%20music%20show%20performance%20analysis%2C%20warm%20coral%20and%20golden%20lighting%2C%20abstract%20play%20button%20design%2C%20modern%20editorial%20style%2C%20soft%20dramatic%20shadows%2C%20clean%20widescreen%20composition%2C%20broadcast%20quality%20aesthetic&width=480&height=300&seq=media-5-heiliao&orientation=landscape',
    title: '选秀冠军假唱实锤：音频波形对比技术分析',
    duration: '10:55',
    views: '59.8万',
    tag: '实锤'
  },
];